export abstract class DateParser<T> {
  abstract parse(value: string): T | null;
}
